import React from 'react';
import {
  FaBuilding,
  FaChartBar,
  FaCog,
  FaDoorOpen,
  FaFileContract,
  FaFileAlt,
  FaMoneyBillWave,
  FaReceipt,
  FaThLarge,
  FaUserFriends,
  FaUserShield,
} from 'react-icons/fa';
import { MODULE_LABELS } from '../config/tenantPermissions';

const MODULE_UI = [
  { key: 'dashboard', description: 'Panel principal', icon: FaThLarge },
  { key: 'inmuebles', description: 'Gestión de inmuebles', icon: FaBuilding },
  { key: 'espacios', description: 'Gestión de espacios', icon: FaDoorOpen },
  { key: 'inquilinos', description: 'Gestión de inquilinos', icon: FaUserFriends },
  { key: 'contabilidad', description: 'Pagos y gastos', icon: FaMoneyBillWave },
  { key: 'contratos', description: 'Gestión de contratos', icon: FaFileContract },
  { key: 'reportes', description: 'Reportes y estadísticas', icon: FaChartBar },
  { key: 'usuarios', description: 'Gestión de cuentas', icon: FaUserShield },
  { key: 'mi_contrato', description: 'Portal del inquilino', icon: FaFileAlt },
  { key: 'mis_pagos', description: 'Recibos y fechas de pago', icon: FaReceipt },
  { key: 'configuracion', description: 'Perfil y contraseña', icon: FaCog },
];

const ModulePermissionGrid = ({ selected, onToggle }) => {
  return (
    <div className="persona-registrar-modules-grid">
      {MODULE_UI.map(({ key, description, icon: Icon }) => {
        const isSelected = selected.includes(key);

        return (
          <label
            key={key}
            className={`persona-registrar-module-card${isSelected ? ' selected' : ''}`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => onToggle(key)}
            />
            <span className={`persona-registrar-module-icon persona-registrar-module-icon--${key}`}>
              <Icon />
            </span>
            <span className="persona-registrar-module-body">
              <strong>{MODULE_LABELS[key]}</strong>
              <small>{description}</small>
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default ModulePermissionGrid;
